<template>
  <el-main style="padding: 30px">
    <el-form ref="form" :model="form">
      <el-form-item label="商品类别">
        <el-radio-group v-model="form.type">
          <el-radio
            v-for="type in types"
            :key="type.index"
            :label="type"></el-radio>
        </el-radio-group>
        <i class="el-icon-loading" style="color: #3a8ee6" v-show="!types[0]"></i>
      </el-form-item>
      <el-form-item label="动作标签">
        <el-radio-group v-model="form.bm_action_label_sign">
          <el-radio label="静默"></el-radio>
          <el-radio label="大推"></el-radio>
          <el-radio label="老货再推"></el-radio>
          <el-radio label="其他"></el-radio>
        </el-radio-group>
        <el-input :disabled="form.bm_action_label_sign !== '其他'" size="mini" v-model="form.bm_action_label_custom" style="width: 300px;"></el-input>
      </el-form-item>
      <el-form-item :label="labels[0]">
        <el-input v-model="form.name" style="width: 400px;"></el-input>
      </el-form-item>
      <el-form-item label="商品图片" v-show="!virtual">
        <el-upload
          :action="uploadUrl"
          :data="{token: this.token}"
          ref="goodPicture"
          list-type="picture-card"
          :before-upload="beforeUpload"
          :file-list="goods_pic_list"
          multiple
          :on-remove="(file, fileList) => remove(file, fileList, 'goods_pic_list')"
          :on-success="(response, file, fileList) => onsuccess(response, file, fileList, 'goods_pic_list')">
          <i class="el-icon-plus" style="line-height: 148px;"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="展示图片" v-show="virtual">
        <el-upload
          :action="uploadUrl"
          :data="{token: this.token}"
          ref="virtualPicture"
          list-type="picture-card"
          limit="1"
          :file-list="virtual_pic_list"
          multiple
          :before-upload="beforeUpload"
          :on-remove="(file, fileList) => remove(file, fileList, 'virtual_pic_list')"
          :on-success="(response, file, fileList) => onsuccess(response, file, fileList, 'virtual_pic_list')">
          <i class="el-icon-plus" style="line-height: 148px;"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="活动详情" v-show="virtual">
        <el-upload
          :action="uploadUrl"
          :data="{token: this.token}"
          ref="virtualDetailPic"
          list-type="picture-card"
          :file-list="virtual_detail_pic_list"
          multiple
          :on-remove="(file, fileList) => remove(file, fileList, 'virtual_detail_pic_list')"
          :on-success="(response, file, fileList) => onsuccess(response, file, fileList, 'virtual_detail_pic_list')">
          <i class="el-icon-plus" style="line-height: 148px;"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="商品规格" v-show="!virtual" class="short-input">
        <el-table :data="form.sku_list" style="width: 90%" :row-class-name="tableRowClassName">
          <el-table-column v-for="item in sku_columns" align="center" :key="item.value" :label="item.label">
            <template v-slot="scope">
              <el-input v-model="scope.row[item.value]"></el-input>
            </template>
          </el-table-column>
          <el-table-column>
            <template v-slot="scope">
              <i class="el-icon-circle-plus-outline cu-icon" @click="addSku(scope.$index)"></i>
              <i class="el-icon-remove-outline cu-icon" v-if="form.sku_list.length > 1" @click="deleteSku(scope.$index)"></i>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="销售数据显示" v-show="!virtual">
        <el-input v-model="form.custom_sales_quantity" style="width: 100px;"></el-input>
        <span> + 真实销量</span>
      </el-form-item>
      <el-form-item :label="labels[1]" style="margin-top: 30px;">
        <label>
          <textarea rows="8" cols="80" v-model="form.goods_message" class="text-space"></textarea>
        </label>
      </el-form-item>
      <el-form-item label="标签">
        <el-tag
          style="margin-right: 15px;"
          :key="tag"
          v-for="tag in form.label_list"
          closable
          @close="closeTag(tag)">
          {{tag}}
        </el-tag>
        <span v-if="form.label_list && form.label_list.length < 3">
          <el-input
            v-if="inputVisible"
            v-model="inputTagValue"
            ref="saveTagInput"
            size="small"
            maxlength="7"
            @keyup.enter.native="handleTagInput"
            @blur="handleTagInput">
          </el-input>
          <el-button v-else size="small" @click="showInput">+ 新标签</el-button>
        </span>
      </el-form-item>
      <el-form-item label="商品图文介绍" v-show="!virtual">
        <el-upload
          :action="uploadUrl"
          :data="{token: this.token}"
          ref="introducePicture"
          list-type="picture-card"
          :file-list="detail_pic_list"
          multiple
          :before-upload="beforeUpload"
          :on-remove="(file, fileList) => remove(file, fileList, 'detail_pic_list')"
          :on-success="(response, file, fileList) => onsuccess(response, file, fileList, 'detail_pic_list')">
          <i class="el-icon-plus" style="line-height: 148px;"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="活动海报" v-show="virtual">
        <el-upload
          :action="uploadUrl"
          :data="{token: this.token}"
          ref="virtualPosterPic"
          list-type="picture-card"
          limit="1"
          :file-list="virtual_poster_pic_list"
          multiple
          :on-remove="(file, fileList) => remove(file, fileList, 'virtual_poster_pic_list')"
          :on-success="(response, file, fileList) => onsuccess(response, file, fileList, 'virtual_poster_pic_list')">
          <i class="el-icon-plus" style="line-height: 148px;"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="海报详情" v-show="virtual">
        <el-upload
          :action="uploadUrl"
          :data="{token: this.token}"
          ref="virtualPosterDetailPic"
          list-type="picture-card"
          limit="1"
          :file-list="virtual_poster_bg_pic_list"
          multiple
          :on-remove="(file, fileList) => remove(file, fileList, 'virtual_poster_bg_pic_list')"
          :on-success="(response, file, fileList) => onsuccess(response, file, fileList, 'virtual_poster_bg_pic_list')">
          <i class="el-icon-plus" style="line-height: 148px;"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="活动链接" v-show="virtual">
        <el-input v-model="form.activity_url" style="width: 250px"></el-input>
      </el-form-item>
      <el-form-item label="活动佣金" v-show="virtual" class="short-input">
        <el-input v-model="form.brokerage_show"></el-input>&emsp;元
      </el-form-item>
      <el-form-item label="上传视频" v-show="!virtual">
        <el-upload
          :action="uploadUrl"
          :data="{token: this.token}"
          :show-file-list="false"
          ref="video"
          :on-success="handleVideoSuccess"
          :before-upload="beforeUploadVideo"
          :on-progress="uploadVideoProcess">
          <video
            style="max-height: 200px"
            v-if="videoUrl && videoFlag === false"
            :src="videoUrl"
            controls="controls">您的浏览器不支持视频播放</video>
          <i v-else-if="!videoUrl && videoFlag === false" class="el-icon-plus avatar-uploader-icon"></i>
          <el-progress v-if="videoFlag === true" type="circle" :percentage="videoUploadPercent" style="margin-top:30px;"></el-progress>
        </el-upload>
        <div class="info">请保证视频格式为mp4</div>
        <el-button class="info white" size="mini" type="warning" @click="clearVideo">{{$route.query.good_id?'删除视频':'去掉视频'}}</el-button>
      </el-form-item>
      <el-form-item label="分享文案" v-show="virtual">
        <label>
          <textarea rows="8" cols="80" v-model="form.desc_text" class="text-space"></textarea>
        </label>
      </el-form-item>
      <el-button type="primary" @click="onSubmit" size="medium" style="margin: 30px 200px; width: 200px;">{{$route.query.join_platform_id ? '同意并提交' : '提交'}}</el-button>
    </el-form>
  </el-main>
</template>

<script>
import Sortable from 'sortablejs'

export default {
  name: 'PersonalForm',
  components: {
    Sortable
  },
  data () {
    return {
      token: sessionStorage.token,
      getCategoryUrl: this.getDomain() + 'bmgoods/get_goods_category', // 获取商品分类
      uploadUrl: this.getDomain() + 'bmuser/upload_oss', // 图片上传
      submitUrl: this.getDomain() + 'bmgoods/add_goods', // 提交商品
      deleteVideoUrl: this.getDomain() + 'bmgoods/del_goods_video', // 删除视频
      submitVirtualUrl: this.getDomain() + 'bmgoods/add_virtual_goods', // 提交虚拟商品
      detailUrl: this.getDomain() + 'bmgoods/get_goods_info', // 商品详情
      joinPlatformDetailUrl: this.getDomain() + 'bmgoods/join_platform_detail',
      processingJoinUrl: this.getDomain() + 'bmgoods/processing_join',
      types: [],
      cate_info: [],
      goods_pic_list: [],
      detail_pic_list: [],
      virtual_pic_list: [],
      virtual_poster_pic_list: [],
      virtual_detail_pic_list: [],
      virtual_poster_bg_pic_list: [],
      videoUrl: undefined,
      videoFlag: false,
      videoUploadPercent: 0,
      good_id: undefined,
      join_platform_id: undefined,
      defaultForm: {
        goods_pic_list: [],
        detail_pic_list: [],
        virtual_pic_list: [],
        virtual_poster_pic_list: [],
        virtual_detail_pic_list: [],
        virtual_poster_bg_pic_list: [],
        label_list: [],
        bm_action_label: undefined,
        custom_sales_quantity: 0,
        token: sessionStorage.token,
        sku_list: [
          {
            'sku_name': undefined,
            'goods_code': undefined,
            'inner_price_show': undefined,
            'cost_price_show': undefined,
            'ori_price_show': undefined,
            'price_show': undefined,
            'inventory': undefined
          }
        ]
      },
      form: Object.assign({}, this.defaultForm),
      inputVisible: false,
      inputTagValue: undefined,
      action_labels: ['静默', '大推', '老货再推'],
      sku_columns: [
        {
          label: '规格',
          value: 'sku_name'
        },
        {
          label: '建议零售价',
          value: 'price_show'
        },
        {
          label: '市场价',
          value: 'ori_price_show'
        },
        {
          label: '团长底价',
          value: 'cost_price_show'
        },
        {
          label: '成本价',
          value: 'inner_price_show'
        },
        {
          label: '商品编码',
          value: 'goods_code'
        },
        {
          label: '库存',
          value: 'inventory'
        }
      ]
    }
  },
  computed: {
    virtual () {
      return this.form.type === '虚拟商品'
    },
    labels () {
      return this.form.type === '虚拟商品' ? ['活动名称', '活动规则'] : ['商品名称', '商品简介(推荐语)']
    }
  },
  methods: {
    getQuery () {
      this.form = Object.assign({}, this.defaultForm)
      this.axios.post(this.getCategoryUrl, {
        token: sessionStorage.token
      }).then((data) => {
        if (data.data.err_code === 0) {
          this.cate_info = data.data.content.cate_info
          data.data.content.cate_info.forEach(item => {
            this.types.push(item.cate_name)
          })
          this.good_id = this.$route.query.good_id
          this.join_platform_id = this.$route.query.join_platform_id
          if (this.good_id || this.join_platform_id) {
            this.getGoodDetail()
          }
        } else {
          this.$message.error(data.data.content.desc)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getGoodDetail () {
      let url = this.good_id ? this.detailUrl : this.joinPlatformDetailUrl
      this.axios.post(url, {
        token: sessionStorage.token,
        good_id: this.good_id,
        join_platform_id: this.join_platform_id
      }).then(res => {
        if (res.data.err_code === 0) {
          this.form = Object.assign({}, this.form, res.data.content.data)
          if (this.action_labels.indexOf(this.form.bm_action_label) > -1) {
            this.form.bm_action_label_sign = this.form.bm_action_label
          } else {
            this.form.bm_action_label_sign = '其他'
            this.form.bm_action_label_custom = this.form.bm_action_label
          }
          if (this.form.cate_id || this.form.name) {
            this.cate_info.forEach(item => {
              if (item.cate_id === parseInt(this.form.cate_id)) {
                this.form.type = item.cate_name
              }
            })
            this.videoUrl = this.form.video_url
            if (this.form.cate_id === 13) {
              this.form.goods_message = this.form.content
              this.form.virtual_pic_list = [this.form.goods_pic]
              this.form.virtual_poster_pic_list = [this.form.poster_pic]
              this.form.virtual_detail_pic_list = this.form.detail_pic_list
              this.form.virtual_poster_bg_pic_list = [this.form.bg_pic]
              this.form.brokerage_show = this.form.brokerage / 100
            } else {
              this.form.sku_list.forEach(item => {
                this.$set(item, 'inner_price_show', item.inner_price / 100 || undefined)
                this.$set(item, 'cost_price_show', item.cost_price / 100 || undefined)
                this.$set(item, 'ori_price_show', item.ori_price / 100 || undefined)
                this.$set(item, 'price_show', item.price / 100 || undefined)
              })
            }
            this.handleOssUrl('goods_pic_list')
            this.handleOssUrl('detail_pic_list')
            this.handleOssUrl('virtual_pic_list')
            this.handleOssUrl('virtual_poster_pic_list')
            this.handleOssUrl('virtual_detail_pic_list')
            this.handleOssUrl('virtual_poster_bg_pic_list')
            this.form = Object.assign({}, this.form)
          }
        } else {
          this.$message.error(res.data.content.desc)
        }
      }).catch(err => {
        this.$message({
          type: 'error',
          message: err.message
        })
      })
    },
    handleForm () {
      this.cate_info.forEach(item => {
        if (item.cate_name === this.form.type) {
          this.form.cate_id = item.cate_id
        }
      })
      if (this.form.bm_action_label_sign !== '其他') {
        this.form.bm_action_label = this.form.bm_action_label_sign
      } else {
        this.form.bm_action_label = this.form.bm_action_label_custom
      }
      this.form.video_url = this.videoUrl
      this.form.custom_sales_quantity = +this.form.custom_sales_quantity
      this.form.content = this.form.goods_message
      this.form.sku_list.forEach(item => {
        item.inner_price = Math.round(item.inner_price_show * 100) || undefined
        item.cost_price = Math.round(item.cost_price_show * 100) || undefined
        item.ori_price = Math.round(item.ori_price_show * 100) || undefined
        item.price = Math.round(item.price_show * 100) || undefined
        item.inventory = item.inventory * 1 || undefined
      })
      this.handleOssUrl('goods_pic_list', 0)
      this.handleOssUrl('detail_pic_list', 0)
      this.handleOssUrl('virtual_pic_list', 0)
      this.handleOssUrl('virtual_poster_pic_list', 0)
      this.handleOssUrl('virtual_detail_pic_list', 0)
      this.handleOssUrl('virtual_poster_bg_pic_list', 0)
      this.form.goods_pic = this.form.virtual_pic_list[0]
      this.form.poster_pic = this.form.virtual_poster_pic_list[0]
      if (this.form.cate_id === 13) {
        this.form.detail_pic_list = this.form.virtual_detail_pic_list
      }
      this.form.bg_pic = this.form.virtual_poster_bg_pic_list[0]
    },
    onSubmit () {
      this.handleForm()
      this.axios.post(this.getUrl(), this.form).then((data) => {
        if (data.data.err_code === 0) {
          if (this.$route.query.good_id) {
            this.$message.success('上传成功')
            this.$router.push('/navmenu/GoodPlatform/good-list')
          } else if (this.$route.query.join_platform_id) {
            this.axios.post(this.processingJoinUrl, {
              token: sessionStorage.token,
              join_platform_id: this.$route.query.join_platform_id,
              type: 1
            }).then(res => {
              if (res.data.err_code === 0) {
                this.$message.success('同意并上传成功')
                this.$router.go(-1)
              } else {
                this.$message.error('审核同意失败，，' + res.data.content.desc)
              }
            })
          } else {
            this.$message.success('上传成功')
            let type = this.form.type
            this.form = Object.assign({type: type}, this.defaultForm)
            this.$refs.goodPicture.clearFiles()
            this.$refs.introducePicture.clearFiles()
            this.$refs.virtualPicture.clearFiles()
            this.$refs.virtualPosterPic.clearFiles()
            this.$refs.virtualDetailPic.clearFiles()
            this.$refs.virtualPosterDetailPic.clearFiles()
            this.videoUrl = undefined
          }
        } else {
          this.$message.error('上传失败，' + data.data.content.desc)
        }
      })
    },
    // 上传图片前检测
    beforeUpload (file) {
      const isLt4M = file.size / 1024 / 1024 < 4
      if (file.type === 'video/mp4') {
        this.$message.error('请上传正确图片格式')
        return false
      }
      if (!isLt4M) {
        this.$message.error('上传图片大小不能超过4MB')
        return false
      }
      return isLt4M
    },
    remove (file, fileList, val) {
      this[val] = fileList
    },
    onsuccess (response, file, fileList, val) {
      if (response.err_code !== 0) {
        this.$alert('图片上传失败', '错误', {
          confirmButtonText: '确定'
        })
      } else {
        this[val] = fileList
      }
    },
    // 判断接口
    getUrl () {
      return this.form.cate_id === 13 ? this.submitVirtualUrl : this.submitUrl
    },
    // 收发图片链接
    handleOssUrl (val, status = 1) {
      if (status) {
        this.form[val].forEach(item => {
          let obj = {name: 'img', url: item, response: {content: {oss_url: item}}}
          this[val].push(obj)
        })
      } else {
        this.form[val] = []
        this[val].forEach(item => {
          this.form[val].push(item.response.content.oss_url)
        })
      }
    },
    beforeUploadVideo (file) {
      if (file.type !== 'video/mp4') {
        this.$message.error('请上传正确的视频格式')
        return false
      }
    },
    uploadVideoProcess (event, file) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0)
    },
    handleVideoSuccess (res) {
      this.videoFlag = false
      this.videoUploadPercent = 0
      if (res.err_code === 0) {
        this.videoUrl = res.content.oss_url
      } else {
        this.$message.error('视频上传失败，请重新上传！')
      }
    },
    clearVideo () {
      if (this.$route.query.good_id) {
        this.$confirm('是否删除此商品的视频?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post(this.deleteVideoUrl, {
            token: sessionStorage.token,
            good_id: this.form.good_id
          }).then(res => {
            if (res.data.err_code === 0) {
              this.$message.success('删除成功')
              this.videoUrl = undefined
            } else {
              this.$message.error(res.data.content.desc)
            }
          })
        })
      } else {
        this.videoUrl = undefined
      }
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    closeTag (tag) {
      this.form.label_list.splice(this.form.label_list.indexOf(tag), 1)
    },
    handleTagInput () {
      if (this.inputTagValue) {
        this.form.label_list.push(this.inputTagValue)
        this.inputVisible = false
        this.inputTagValue = ''
      }
    },
    tableRowClassName ({rowIndex}) {
      if (rowIndex % 2) {
        return 'gray-row'
      } else {
        return ''
      }
    },
    addSku (index) {
      let blank = {
        'sku_name': undefined,
        'goods_code': undefined,
        'inner_price': undefined,
        'cost_price': undefined,
        'ori_price': undefined,
        'price': undefined,
        'inventory': undefined
      }
      this.form.sku_list.splice(index + 1, 0, blank)
    },
    deleteSku (index) {
      let act = () => {
        this.form.sku_list.splice(index, 1)
      }
      this.__confirm('确认删除？', act)
    },
    rowDrop () {
      let tbody = document.querySelector('.el-table__body-wrapper tbody')
      let self = this
      Sortable.create(tbody, {
        onEnd: function (evt) {
          self.form.sku_list.splice(evt.newIndex, 0, self.form.sku_list.splice(evt.oldIndex, 1)[0])
          let newArray = self.form.sku_list.slice(0)
          self.form.sku_list = []
          self.$nextTick(function () {
            self.form.sku_list = newArray
          })
        }
      })
    }
  },
  mounted () {
    this.getQuery()
    this.rowDrop()
  }
}
</script>

<style scoped>
  .short-input .el-input{
    width: 90px
  }
  span {
    color: #606266;
  }

  .text-space {
    white-space: pre;
  }

  .info {
    color: #999999;
    font-size: 13px;
    margin-left: 70px;
  }

  .avatar-uploader-icon {
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 248px;
    height: 148px;
    line-height: 148px;
    vertical-align: top;
    font-size: 28px;
    color: #8c939d;
  }

  .white {
    color: white;
  }

  .cu-icon {
    font-size: 25px;
    line-height: 30px;
    cursor: pointer;
    color: #409EFF;
    margin-right: 10px;
  }

  .el-table >>> .gray-row {
    background: rgba(238, 238, 238, 0.5);
  }
</style>
